import React from 'react';
import ModalOverlay from '../../shared/ModalOverlay';
import { Vendor } from '../../types';

interface VendorInfoModalProps {
  active: boolean;
  onClose: () => void;
  vendor: Vendor | null;
  infoType: 'location' | 'shipping';
}

const VendorInfoModal: React.FC<VendorInfoModalProps> = ({ active, onClose, vendor, infoType }) => {
  if (!vendor) return null;

  const isLocation = infoType === 'location';
  const title = `${vendor.vendor_name} — ${isLocation ? 'Location' : 'Shipping'}`;

  const fields = isLocation
    ? [
        { label: 'Address', value: vendor.loc_address },
        { label: 'City', value: vendor.loc_city },
        { label: 'State / Province', value: vendor.loc_state },
        { label: 'Country', value: vendor.loc_country },
        { label: 'Zip Code', value: vendor.loc_zip },
        { label: 'Phone', value: vendor.loc_phone },
      ]
    : [
        { label: 'Address', value: vendor.ship_address },
        { label: 'City', value: vendor.ship_city },
        { label: 'State / Province', value: vendor.ship_state },
        { label: 'Country', value: vendor.ship_country },
        { label: 'Zip Code', value: vendor.ship_zip },
        { label: 'Phone', value: vendor.ship_phone },
      ];

  return (
    <ModalOverlay active={active} onClose={onClose}>
      <div className="modal modal-sm">
        <div className="modal-header">
          <h2>{title}</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <div className="view-grid" style={{ gridTemplateColumns: '1fr' }}>
          {fields.map((f) => (
            <div key={f.label} className="view-field">
              <div className="label">{f.label}</div>
              <div className="val">{f.value || '—'}</div>
            </div>
          ))}
        </div>
        <div className="form-actions">
          <button className="btn btn-secondary" onClick={onClose}>Close</button>
        </div>
      </div>
    </ModalOverlay>
  );
};

export default VendorInfoModal;
